import { Dropdown, Typography } from '@sanlam-glacier/app-common/components';
import styles from './statement-form-sections.module.scss';
import { Control, Controller } from 'react-hook-form';
import { filterInvestmentsBySelectedNames } from 'modules/clients/utils/statement-form-helper';
import { InvestmentModelMock } from 'modules/clients/types/client.interfaces';
import { StatementFormValues } from 'modules/clients/types/client.types';

type InvestmentsDropdownProps = {
  control: Control<StatementFormValues, StatementFormValues, StatementFormValues>;
  multiSelect: boolean;
  clientInvestments: InvestmentModelMock[];
  assistiveText: string;
};
export const InvestmentsDropdown = ({
  control,
  multiSelect,
  clientInvestments,
  assistiveText
}: InvestmentsDropdownProps) => {
  const investmentTypesList = clientInvestments.map((inv) => inv.investmentName);

  return (
    <div className={styles.selectionContainers}>
      <Typography
        variant={Typography.VARIANT.H5}
        weight={Typography.WEIGHT.MEDIUM}
        color={Typography.COLOR.DEFAULT}
      >
        {multiSelect ? 'Investments' : 'Investment'}
      </Typography>
      <Controller
        name='investments'
        control={control}
        render={({ field }) => (
          <Dropdown
            selectAllLabel='All investments'
            allSelectedLabel='All investments'
            className={styles.filter}
            placeholder={
              field.value.length > 0
                ? undefined
                : multiSelect
                  ? 'Select investments'
                  : 'Select investment'
            }
            multiSelect={multiSelect}
            allowSelectAll
            chipLimit={2}
            items={investmentTypesList}
            maxHeight={224}
            onChange={(items) =>
              field.onChange(filterInvestmentsBySelectedNames(items, clientInvestments))
            }
            popperPlacement={Dropdown.POSITION.BOTTOM}
            assistiveText={assistiveText}
          />
        )}
      />
    </div>
  );
};
